import React from 'react'
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {Outlet} from "react-router-dom";
const ReportsPage = ({children}) => {
    return(<React.Fragment>
        <DashboardLayout>
            {children || <Outlet/>}
        </DashboardLayout>
    </React.Fragment>)
}

export default ReportsPage